import GooglePlacesAutocomplete, {
  geocodeByPlaceId,
  getLatLng,
} from "react-google-places-autocomplete";
import { useTranslation } from "react-i18next";

const GooglePlacesInput = ({ onPlaceSelected, onInputChange, value }) => {
  const { t } = useTranslation();
  const handleSelect = async (newValue) => {
    if (!newValue) {
      onPlaceSelected(null);
      return;
    }

    const placeId = newValue?.value?.place_id;

    if (placeId) {
      try {
        const results = await geocodeByPlaceId(placeId);
        const latLng = await getLatLng(results[0]);
        onPlaceSelected({
          address: newValue.label,
          latitude: latLng.lat,
          longitude: latLng.lng,
        });
      } catch (error) {
        console.error("Error fetching geolocation:", error);
      }
    }
  };

  const handleChange = (newValue) => {
    onInputChange(newValue);
  };

  return (
    <GooglePlacesAutocomplete
      autocompletionRequest={{
        componentRestrictions: { country: "tn" },
      }}
      selectProps={{
        value: value,
        onChange: handleSelect,
        onInputChange: handleChange,
        placeholder: `${t("Entrez une adresse")}`,
        isClearable: true,
      }}
      onLoadFailed={(error) =>
        console.error("Autocomplete load failed:", error)
      }
    />
  );
};

export default GooglePlacesInput;
